import { render, staticRenderFns } from "./Injection.vue?vue&type=template&id=b0dd9d68&scoped=true"
import script from "./Injection.vue?vue&type=script&lang=js"
export * from "./Injection.vue?vue&type=script&lang=js"
import style0 from "./Injection.vue?vue&type=style&index=0&id=b0dd9d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd9d68",
  null
  
)

export default component.exports